import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { TrpcService } from '../../services/trpc/trpc.service';

@Component({
  selector: 'app-test-logout',
  templateUrl: './test-logout.component.html',
  styleUrls: ['./test-logout.component.scss']
})
export class TestLogoutComponent implements OnInit {
  logoutMessage: string = '';
  isLoggingOut: boolean = false;
  logoutComplete: boolean = false;
  cookieInfoBeforeLogout: string = '';

  constructor(
    private authService: AuthService,
    private trpcService: TrpcService,
    private router: Router
  ) {}

  ngOnInit() {
    this.performLogout();
  }

  performLogout() {
    this.isLoggingOut = true;

    try {
      // Capture current cookie info before clearing
      if (this.authService.cookieData) {
        this.cookieInfoBeforeLogout = `Session: ${this.authService.cookieData.cookie.name} = ${this.authService.cookieData.cookie.value.substring(0, 20)}...`;
      } else {
        this.cookieInfoBeforeLogout = 'No active session found';
      }

      console.log('Starting logout process...');
      console.log('Current cookie data:', this.authService.cookieData);

      // Clear the authentication cookie from localStorage
      this.authService.clearCookieFromStorage();
      console.log('Cookie cleared from localStorage');

      // Reset TrpcService token to empty state
      this.trpcService.setToken({ cookie: { name: '', value: '' } });
      console.log('TrpcService token reset');

      // Build success message
      this.logoutMessage = 'Logout successful! All authentication tokens have been cleared from local storage.';
      this.logoutComplete = true;

    } catch (error: any) {
      console.error('Logout error:', error);
      this.logoutMessage = `Logout failed: ${error.message || 'Unknown error occurred'}`;
      this.logoutComplete = true;
    } finally {
      this.isLoggingOut = false;
    }
  }

  navigateToLogin() {
    console.log('Navigating to test login page...');
    this.router.navigate(['/dev/test-login']);
  }

  navigateToDashboard() {
    console.log('Navigating to dashboard...');
    this.router.navigate(['/dashboard']);
  }
}
